module.exports = __webpack_public_path__ + "img/dateapproval.9b7c4e94.svg";